import { useEffect, useState } from 'react'
import TimeHelper from '../../helpers/TimeHelper'
import ChristmasDecorations from './ChristmasDecorations'

interface DecorationsProps {
    type?: 'christmas' | 'easter' | 'halloween' | 'auto'
}

const Decorations = ({ type = 'auto' }: DecorationsProps) => {
    const [activeType, setActiveType] = useState<string>('')

    useEffect(() => {
        if (type === 'auto') {
            if (TimeHelper.isChristmas()) setActiveType('christmas')

            // else if (TimeHelper.isEaster()) setActiveType('easter')
            // else if (TimeHelper.isHalloween()) setActiveType('halloween')
            else setActiveType(null)
        } else {
            setActiveType(type)
        }
    }, [type])

    if (!activeType) return null

    switch (activeType) {
        case 'christmas':
            return <ChristmasDecorations />
        case 'easter':
            return null
        case 'halloween':
            return null
        default:
            return null
    }
}

export default Decorations
